// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2gH0-","list":"PatternAutocomplete_list__26bT0"};